<template>
  <div>
    <div class="navbar bg-color fixed-nav" style="z-index: 1000; box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.75);">
      <div style="position: relative; display: flex; justify-content: space-between; min-height: 100px; align-items: center; width: 90%; margin: auto;">
        <div style="display: flex; align-items: center;">
          <v-img
            src="@/assets/logos/Logotipo_Dos tintas.png"
            alt="fresher-logo"
            @click="scrollToSection('Home')"
            contain
            class="logo-img-navbar mr-4"
          ></v-img>
          <div class="hidden-md-and-down">
            <v-btn text @click="scrollToSection('Home')" class="nav-link" style="color: #193D6E; font-family: 'montserrat-bold';">{{ selectLanguage === 'sp' ? 'Inicio' : 'Home' }}</v-btn>
            <v-btn text @click="scrollToSection('Agents')" class="nav-link" style="color: #193D6E; font-family: 'montserrat-bold';">{{ selectLanguage === 'sp' ? 'Agentes' : 'Agents' }}</v-btn>
            <v-btn text @click="scrollToSection('Faq')" class="nav-link" style="color: #193D6E; font-family: 'montserrat-bold';">FAQ</v-btn>
          </div>
        </div>

        <div class="navbar-actions">
          <div class="hidden-md-and-down navbar-actions-inner">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div class="lang-switch" v-bind="attrs" v-on="on">
                  <img
                    v-if="selectLanguage == 'sp'"
                    class="lang-flag"
                    src="@/assets/images/Flags_mex.svg"
                    alt="fresher-lang"
                  />
                  <img
                    v-else
                    class="lang-flag"
                    src="@/assets/images/Flags_usa.svg"
                    alt="fresher-lang"
                  />
                  <v-icon size="18">mdi-menu-down</v-icon>
                </div>
              </template>
              <language-component style="background-color: white; padding: 15px;"></language-component>
            </v-menu>
            <v-btn text @click="redirectToLogin" class="nav-signin-btn">{{ selectLanguage === 'sp' ? 'Iniciar sesión' : 'Sign in' }}</v-btn>
            <v-btn elevation="0" @click="redirectToRegister" class="Register-button">{{ selectLanguage === 'sp' ? 'Crear cuenta' : 'Sign up' }}</v-btn>
          </div>
          <div class="d-lg-none">
            <v-btn elevation="0" small @click="redirectToRegister" class="Register-button">{{ selectLanguage === 'sp' ? 'Crear cuenta' : 'Sign up' }}</v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-container" style="padding-top: 100px;">
      <section id="Home" class="home-section">
        <v-container fluid class="hero-section">
          <v-row class="align-center" justify="center">
            <v-col cols="12" md="9" class="text-section text-center">
              <span class="hero-eyebrow">{{ selectLanguage === 'sp' ? 'FRESHER AI' : 'FRESHER AI' }}</span>
              <h1 class="hero-title">
                {{ selectLanguage === 'sp' ? 'Agentes de ' : 'AI ' }}<span class="highlight">{{ selectLanguage === 'sp' ? 'Inteligencia Artificial' : 'Agents' }}</span>{{ selectLanguage === 'sp' ? ' que trabajan para tu negocio, 24/7' : ' that work for your business, 24/7' }}
              </h1>
              <p class="hero-subtitle">
                {{ selectLanguage === 'sp' ? 'Automatiza riesgo, cobranza, ventas e inteligencia de precios sin salir de Fresher.' : 'Automate risk, collections, sales and price intelligence without leaving Fresher.' }}
              </p>
              <div class="hero-actions justify-center">
                <v-btn class="custom-button" large @click="redirectToRegister">
                  {{ selectLanguage === 'sp' ? 'Crear cuenta gratis' : 'Create free account' }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn text large @click="redirectToLogin" class="nav-signin-btn">
                  {{ selectLanguage === 'sp' ? 'Ya tengo cuenta' : 'I already have an account' }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="Agents" class="pa-10 px-14">
        <v-container fluid class="agents-section">
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <h2 class="section-title">{{ selectLanguage === 'sp' ? 'Un agente para cada operación clave' : 'An agent for every key operation' }}</h2>
              <p class="section-subtitle">{{ selectLanguage === 'sp' ? 'Empieza con Riesgo · Más agentes en camino' : 'Start with Risk · More agents coming soon' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="agent in agents" :key="agent.id" cols="12" sm="6" md="3">
              <v-card class="agent-card" :class="{ 'agent-card-live': agent.available }" elevation="0">
                <div class="agent-card-top">
                  <span class="agent-icon" :style="{ backgroundColor: agent.background }">
                    <v-icon :color="agent.color" size="26">{{ agent.icon }}</v-icon>
                  </span>
                  <v-chip small :color="agent.available ? '#0075B8' : 'grey darken-2'" text-color="white" label>
                    {{ agent.available ? (selectLanguage === 'sp' ? 'Disponible' : 'Available') : (selectLanguage === 'sp' ? 'Próximamente' : 'Coming soon') }}
                  </v-chip>
                </div>
                <h3>{{ selectLanguage === 'sp' ? agent.name : agent.nameEn }}</h3>
                <p>{{ selectLanguage === 'sp' ? agent.description : agent.descriptionEn }}</p>
                <ul>
                  <li v-for="(feature, idx) in (selectLanguage === 'sp' ? agent.features : agent.featuresEn)" :key="idx">
                    <v-icon size="14" color="#0075B8">mdi-check</v-icon>{{ feature }}
                  </li>
                </ul>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="HowItWorks" style="background: linear-gradient(to bottom, #f2f2f4 0%, #DBE7F3 50%, #f2f2f4 100%);">
        <v-container class="how-section">
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <h2 class="section-title">{{ selectLanguage === 'sp' ? '¿Cómo funciona?' : 'How does it work?' }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center" class="steps-container">
            <v-col cols="12" md="4" v-for="step in steps" :key="step.number">
              <v-card class="step-card" elevation="0">
                <span class="step-number">{{ step.number }}</span>
                <h3>{{ selectLanguage === 'sp' ? step.title : step.titleEn }}</h3>
                <p>{{ selectLanguage === 'sp' ? step.description : step.descriptionEn }}</p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="Why">
        <v-container class="why-section">
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <h2 class="section-title">{{ selectLanguage === 'sp' ? '¿Por qué Fresher AI?' : 'Why Fresher AI?' }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center" class="benefits-container">
            <v-col cols="12" md="3" v-for="benefit in benefits" :key="benefit.icon">
              <v-card class="benefit-card">
                <div class="benefit-icon">
                  <v-img :src="benefit.icon" width="35" height="35" contain></v-img>
                </div>
                <p class="mb-0" style="font-family: 'montserrat-semibold';">{{ selectLanguage === 'sp' ? benefit.text : benefit.textEn }}</p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="Faq">
        <v-container class="faq-container">
          <h2 class="faq-title">{{ selectLanguage === 'sp' ? 'Preguntas Frecuentes' : 'Frequently Asked Questions' }}</h2>
          <v-expansion-panels class="faq-list">
            <v-expansion-panel
              v-for="(faq, index) in faqs"
              :key="index"
              class="faq-item"
              style="box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); margin-bottom: 20px;"
              @change="togglePanel(index)"
            >
              <v-expansion-panel-header class="faq-header">
                <span class="faq-question">{{ selectLanguage === 'sp' ? faq.questionMX : faq.questionEN }}</span>
                <template v-slot:actions>
                  <v-img v-if="panelActive[index]" src="../../assets/Landing/faq-active.png" style="width: 30px;"></v-img>
                  <div v-else style="box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); width: 30px; height: 30px; border-radius: 20px; display: flex;">
                    <v-img src="../../assets/Landing/faq-disabled.svg" contain style="margin: 10px 0px"></v-img>
                  </div>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="faq-content" style="text-align: start; padding: 9px !important">
                {{ selectLanguage === 'sp' ? faq.answerMX : faq.answerEN }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </section>

      <section id="FinalCta" class="pa-10">
        <v-container class="final-cta-section text-center">
          <h2 class="final-cta-title">{{ selectLanguage === 'sp' ? 'Empieza a usar Agentes de IA hoy' : 'Start using AI Agents today' }}</h2>
          <p class="final-cta-subtitle">{{ selectLanguage === 'sp' ? 'Crea tu cuenta y activa tu primer agente en minutos.' : 'Create your account and activate your first agent in minutes.' }}</p>
          <v-btn class="custom-button" large @click="redirectToRegister">
            {{ selectLanguage === 'sp' ? 'Crear cuenta gratis' : 'Create free account' }}
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-container>
      </section>
    </div>

    <footerLanding-component :texts="footerTexts" />
  </div>
</template>

<script>
export default {
  name: "AgentsLandingView",
  data() {
    return {
      panelActive: {},
      agents: [
        {
          id: 'risk', name: 'Agente de Riesgo', nameEn: 'Risk Agent', available: true,
          icon: 'mdi-shield-check-outline', color: '#1976d2', background: '#eaf4fe',
          description: 'Evalúa con quién haces negocios antes de dar el siguiente paso.',
          descriptionEn: 'Assess who you are doing business with before taking the next step.',
          features: ['Validación de personas y empresas', 'Consultas en México y Estados Unidos', 'Señales de riesgo y reportes'],
          featuresEn: ['Person and company validation', 'Checks in Mexico and the United States', 'Risk signals and reports'],
        },
        {
          id: 'collections', name: 'Agente de Cobranza', nameEn: 'Collections Agent', available: false,
          icon: 'mdi-phone-outline', color: '#7453b9', background: '#f2edfb',
          description: 'Da seguimiento a tu cartera y mantén a la vista cada compromiso de pago.',
          descriptionEn: 'Track your portfolio and keep every payment commitment in sight.',
          features: ['Priorización de cuentas', 'Seguimiento de promesas de pago', 'Alertas y recordatorios'],
          featuresEn: ['Account prioritization', 'Payment promise follow-up', 'Alerts and reminders'],
        },
        {
          id: 'sales', name: 'Agente de Ventas', nameEn: 'Sales Agent', available: false,
          icon: 'mdi-bullhorn-outline', color: '#bd7832', background: '#fff4e8',
          description: 'Organiza tus oportunidades y acompaña a tus prospectos durante el proceso comercial.',
          descriptionEn: 'Organize your opportunities and support your prospects through the sales process.',
          features: ['Organización de prospectos', 'Comunicación personalizada', 'Seguimiento de oportunidades'],
          featuresEn: ['Prospect organization', 'Personalized communication', 'Opportunity tracking'],
        },
        {
          id: 'pricing', name: 'Inteligencia de Precios', nameEn: 'Price Intelligence', available: false,
          icon: 'mdi-chart-line', color: '#258779', background: '#eaf6f2',
          description: 'Encuentra contexto para ajustar tus precios y cuidar el margen de tu operación.',
          descriptionEn: 'Find context to adjust your prices and protect your operating margin.',
          features: ['Análisis de precios', 'Señales y oportunidades de mercado', 'Apoyo para decisiones de margen'],
          featuresEn: ['Price analysis', 'Market signals and opportunities', 'Margin decision support'],
        },
      ],
      steps: [
        { number: '1', title: 'Crea tu cuenta', titleEn: 'Create your account', description: 'Regístrate gratis en minutos.', descriptionEn: 'Sign up for free in minutes.' },
        { number: '2', title: 'Elige tu agente', titleEn: 'Choose your agent', description: 'Selecciona el agente de IA que tu operación necesita hoy.', descriptionEn: 'Select the AI agent your operation needs today.' },
        { number: '3', title: 'Actívalo', titleEn: 'Activate it', description: 'Compra créditos o suscríbete y empieza a usarlo de inmediato.', descriptionEn: 'Buy credits or subscribe and start using it right away.' },
      ],
      benefits: [
        { icon: require('@/assets/Landing/sun.svg'), text: 'Disponible 24/7', textEn: 'Available 24/7' },
        { icon: require('@/assets/Landing/shield.svg'), text: 'Seguridad y control de tus datos', textEn: 'Security and control over your data' },
        { icon: require('@/assets/Landing/world.svg'), text: 'Cobertura en México y Estados Unidos', textEn: 'Coverage in Mexico and the United States' },
        { icon: require('@/assets/Landing/info.svg'), text: 'Información clara para tomar decisiones', textEn: 'Clear information to make decisions' },
      ],
      faqs: [
        {
          questionMX: '¿Qué es un Agente de IA de Fresher?',
          answerMX: 'Es una herramienta automatizada que ejecuta tareas específicas de tu operación, como validar riesgo o dar seguimiento a cobranza, usando inteligencia artificial directamente desde tu cuenta de Fresher.',
          questionEN: 'What is a Fresher AI Agent?',
          answerEN: 'It is an automated tool that runs specific tasks for your operation, like risk validation or collections follow-up, using artificial intelligence directly from your Fresher account.',
        },
        {
          questionMX: '¿Necesito una suscripción para usarlos?',
          answerMX: 'Puedes activar los agentes con una suscripción mensual o comprando créditos que se consumen por uso, lo que se ajuste mejor a tu operación.',
          questionEN: 'Do I need a subscription to use them?',
          answerEN: 'You can activate the agents with a monthly subscription or by buying credits that are consumed per use, whichever fits your operation best.',
        },
        {
          questionMX: '¿Mis datos están seguros?',
          answerMX: 'Sí. Todas las consultas y datos se procesan de forma segura y solo se usan para brindarte los resultados que solicitas.',
          questionEN: 'Is my data secure?',
          answerEN: 'Yes. All queries and data are processed securely and are only used to deliver the results you request.',
        },
        {
          questionMX: '¿Cuándo estarán disponibles los demás agentes?',
          answerMX: 'El Agente de Riesgo ya está disponible. Cobranza, Ventas e Inteligencia de Precios se irán habilitando próximamente.',
          questionEN: 'When will the other agents be available?',
          answerEN: 'The Risk Agent is already available. Collections, Sales and Price Intelligence will be enabled soon.',
        },
      ],
    };
  },
  computed: {
    selectLanguage() {
      return this.$store.state.language;
    },
    footerTexts() {
      return {
        FooterLanding: this.selectLanguage === 'sp'
          ? {
            central: 'FRESHER, la plataforma con Agentes de IA que automatizan riesgo, cobranza, ventas e inteligencia de precios para tu negocio.',
            TC: 'Términos y Condiciones',
            central2: 'Todos los derechos reservados FRESHER',
            Created: 'Creado por FRESHER',
          }
          : {
            central: 'FRESHER, the platform with AI Agents that automate risk, collections, sales and price intelligence for your business.',
            TC: 'Terms and Conditions',
            central2: 'All rights reserved FRESHER',
            Created: 'Created by FRESHER',
          },
      };
    },
  },
  methods: {
    scrollToSection(sectionId) {
      const targetElement = document.getElementById(sectionId);
      if (targetElement) {
        const offset = 100;
        const targetPosition = targetElement.offsetTop - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    },
    redirectToLogin() {
      this.$router.push('/login').catch(() => {});
    },
    redirectToRegister() {
      this.$router.push('/register').catch(() => {});
    },
    togglePanel(index) {
      this.$set(this.panelActive, index, !this.panelActive[index]);
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
}
.navbar {
  padding: 0px 24px;
}
.nav-link {
  font-family: 'RethinkSans-Regular', sans-serif;
  font-size: 16px;
  color: #0075b8;
}
.navbar .nav-link:hover {
  color: #2D2D2D !important;
}
.navbar-actions {
  display: flex;
  align-items: center;
}
.navbar-actions-inner {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lang-switch {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.lang-flag {
  width: 22px;
  height: 22px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
}
.nav-signin-btn {
  height: 42px !important;
  font-size: 14px !important;
  font-family: 'montserrat-semibold';
  color: #193D6E !important;
  text-transform: none;
  letter-spacing: normal;
}
.Register-button {
  background-color: #0075B8 !important;
  color: white !important;
  font-size: 14px !important;
  padding: 0 28px !important;
  height: 42px !important;
  min-width: auto !important;
  border-radius: 24px;
  font-family: 'montserrat-semibold';
  text-transform: none;
  letter-spacing: normal;
  box-shadow: 0 4px 10px rgba(0, 117, 184, 0.25) !important;
}
.fixed-nav {
  position: fixed;
  width: 100%;
  z-index: 99999;
  margin-top: 0px;
}
.bg-color {
  height: 100px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  background-color: rgba(191, 215, 237);
}
.logo-img-navbar {
  cursor: pointer;
  max-width: 285px;
  width: 100%;
  height: auto;
}
@media (max-width: 600px) {
  .logo-img-navbar {
    max-width: 130px;
  }
}
.home-section {
  background: linear-gradient(to bottom, #FFFFFF 0%, #DBE7F3 50%, #f2f2f4 100%);
}
.hero-section {
  padding: 90px 20px 70px;
  max-width: 1100px;
  margin: 0 auto;
}
.text-section {
  padding: 20px;
  margin: 0 auto;
}
.hero-eyebrow {
  display: inline-block;
  font-size: 13px;
  letter-spacing: 3px;
  font-family: 'montserrat-bold';
  color: #0075B8;
  background: rgba(0, 117, 184, 0.08);
  padding: 6px 18px;
  border-radius: 20px;
  margin-bottom: 18px;
}
.hero-title {
  margin: 0 auto;
  max-width: 900px;
  font-size: 60px;
  font-family: 'montserrat-bold';
  color: #193D6E;
  line-height: 1.15;
  letter-spacing: -0.5px;
}
.highlight {
  color: #0075B8;
}
.hero-subtitle {
  font-size: 20px;
  color: #64748B;
  font-family: 'montserrat-semibold';
  margin: 24px auto 34px;
  max-width: 620px;
}
.hero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.custom-button {
  background: #0075B8 !important;
  color: white !important;
  border-radius: 30px;
  font-family: 'montserrat-semibold';
  text-transform: none;
  letter-spacing: normal;
  padding: 0 30px !important;
  box-shadow: 0 4px 10px rgba(0, 117, 184, 0.25) !important;
}
.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #193D6E;
  font-family: 'montserrat-bold';
}
.section-subtitle {
  font-size: 16px;
  color: #64748B;
  font-family: 'montserrat-semibold';
  margin-top: 8px;
}
.agents-section {
  max-width: 1300px;
}
.agent-card {
  height: 100%;
  padding: 22px;
  border: 1px solid #e2e7ed;
  border-radius: 16px;
  background: white;
}
.agent-card-live {
  border-color: #b4d7f5;
  box-shadow: 0 3px 12px rgba(0, 117, 184, 0.08);
}
.agent-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.agent-icon {
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
}
.agent-card h3 {
  font-family: 'montserrat-bold';
  font-size: 18px;
  color: #193D6E;
  margin-bottom: 8px;
}
.agent-card p {
  font-size: 13px;
  color: #64748B;
  line-height: 1.6;
  min-height: 65px;
}
.agent-card ul {
  list-style: none;
  padding: 0;
  margin-top: 12px;
}
.agent-card li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #526176;
  margin-bottom: 8px;
}
.how-section {
  padding: 60px 20px;
}
.steps-container {
  margin-top: 20px;
}
.step-card {
  height: 100%;
  padding: 30px;
  border-radius: 16px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  text-align: center;
}
.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #0075B8;
  color: white;
  font-family: 'montserrat-bold';
  margin-bottom: 16px;
}
.step-card h3 {
  font-family: 'montserrat-bold';
  color: #193D6E;
  font-size: 18px;
  margin-bottom: 8px;
}
.step-card p {
  font-size: 14px;
  color: #64748B;
}
.why-section {
  padding: 50px 20px;
}
.benefits-container {
  margin-top: 20px;
}
.benefit-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  border-radius: 12px;
  background: white;
  min-height: 100px;
  height: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.benefit-icon {
  background-color: #BFD7ED;
  padding: 15px;
  border-radius: 15px;
  margin-right: 20px;
}
.faq-container {
  max-width: 1100px;
  padding: 40px 20px;
  text-align: center;
}
.faq-title {
  font-size: 40px;
  font-family: 'montserrat-bold';
  color: #193D6E;
  margin-bottom: 30px;
}
.faq-list {
  background: transparent;
}
.faq-item {
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px 0px;
  border-radius: 20px;
}
.faq-header {
  font-size: 20px;
  font-weight: bold;
  color: #193D6E;
  padding: 16px;
  padding-left: 30px;
}
.faq-content {
  font-size: 16px;
  color: #64748B;
  background: white;
}
.final-cta-section {
  max-width: 800px;
}
.final-cta-title {
  font-size: 32px;
  font-family: 'montserrat-bold';
  color: #193D6E;
}
.final-cta-subtitle {
  font-size: 16px;
  color: #64748B;
  margin: 12px 0 24px;
}
@media (max-width: 960px) {
  .hero-title {
    font-size: 32px;
  }
  .hero-subtitle {
    font-size: 16px;
  }
  .hero-actions {
    justify-content: center;
  }
  .section-title {
    font-size: 26px;
  }
  .faq-title {
    font-size: 30px;
  }
}
</style>
